import React from "react";
import { Search } from "lucide-react";

export const FilterBar = ({ filters, onChange, onSearch, search, searchPlaceholder, children }) => {
  const thisYear = new Date().getFullYear();
  const tahunOpts = [{ value: 'all', label: 'Semua Tahun' }, ...Array.from({ length: 8 }, (_, i) => ({ value: thisYear - i, label: String(thisYear - i) }))];

  const inputStyle = {
    padding: "8px 12px", border: "1.5px solid #E2E8F0", borderRadius: 8,
    fontSize: 13, outline: "none", background: "white", fontFamily: "inherit",
    color: "#374151", cursor: "pointer",
  };
  const labelStyle = {
    display: "block", fontSize: 11, fontWeight: 700, color: "#64748B",
    textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 5,
  };

  return (
    <div style={{
      background: "linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)",
      border: "1.5px solid #E2E8F0", borderRadius: 12, padding: "16px 20px",
      marginBottom: 20, display: "flex", alignItems: "flex-end",
      gap: 16, flexWrap: "wrap",
    }}>
      <div>
        <label style={labelStyle}>Tahun Anggaran</label>
        <select value={filters.tahun || 'all'} onChange={e => onChange({ ...filters, tahun: e.target.value })}
          style={{ ...inputStyle, minWidth: 120, fontWeight: 700 }}>
          {tahunOpts.map(y => <option key={y.value} value={y.value}>{y.label}</option>)}
        </select>
      </div>
      <div>
        <label style={labelStyle}>Mulai Tanggal</label>
        <input type="date" value={filters.dari} onChange={e => onChange({ ...filters, dari: e.target.value })}
          style={{ ...inputStyle, minWidth: 150 }}
          onFocus={e => e.target.style.borderColor = "#2563EB"}
          onBlur={e => e.target.style.borderColor = "#E2E8F0"}
        />
      </div>
      <div>
        <label style={labelStyle}>Sampai Tanggal</label>
        <input type="date" value={filters.sampai} onChange={e => onChange({ ...filters, sampai: e.target.value })}
          style={{ ...inputStyle, minWidth: 150 }}
          onFocus={e => e.target.style.borderColor = "#2563EB"}
          onBlur={e => e.target.style.borderColor = "#E2E8F0"}
        />
      </div>
      {children}
      <div style={{ flex: 1, minWidth: 200 }}>
        <label style={labelStyle}>Pencarian</label>
        <div style={{ position: "relative" }}>
          <Search size={14} style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)", color:"#9CA3AF", pointerEvents:"none" }}/>
          <input value={search} onChange={e => onSearch(e.target.value)}
            placeholder={searchPlaceholder || "Cari…"}
            style={{ ...inputStyle, width: "100%", paddingLeft: 32, boxSizing: "border-box" }}
            onFocus={e => e.target.style.borderColor = "#2563EB"}
            onBlur={e => e.target.style.borderColor = "#E2E8F0"}
          />
        </div>
      </div>
      {(filters.dari || filters.sampai || search) && (
        <div>
          <label style={{ ...labelStyle, opacity: 0 }}>.</label>
          <button onClick={() => { onChange({ ...filters, dari:"", sampai:"" }); onSearch(""); }}
            style={{ ...inputStyle, background: "#FEF2F2", border: "1.5px solid #FECACA",
              color: "#DC2626", fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}>
            Reset
          </button>
        </div>
      )}
    </div>
  );
};

export const buildQS = (filters, search, extra = {}) => {
  const p = { limit: 200 };
  if (filters.tahun && filters.tahun !== 'all') p.tahun = filters.tahun;
  if (filters.dari)   p.dari   = filters.dari;
  if (filters.sampai) p.sampai = filters.sampai;
  if (search)         p.search = search;
  Object.assign(p, extra);
  return "?" + new URLSearchParams(p).toString();
};

export const initFilters = () => ({
  tahun:  "",
  dari:   "",
  sampai: "",
});
